export const mobileNav = $state({ open: false, tab: 'menu' });

export function openMobileNav(tab: 'menu' | 'tours' = 'menu') {
	mobileNav.tab = tab;
	mobileNav.open = true;
}
